import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FileReference, UploadStatus } from './FileUpload';

interface PreviewFileReferenceProps {
    fileReference: FileReference | null;
    removeFile: (file: FileReference) => void;
}

export function PreviewFileReference({ fileReference, removeFile }: PreviewFileReferenceProps) {
    if (!fileReference) {
        return null;
    }

    return (
        <ul className='grid grid-cols-3 gap-2 mt-2'>
            <li className='group block w-full h-32 rounded-md shadow-md overflow-hidden relative' onClick={() => { if (fileReference.uploadStatus === UploadStatus.Completed) { removeFile(fileReference); } }} key={fileReference.previewUrl} >

                {fileReference.uploadStatus === UploadStatus.InProgress && (
                    <div className='absolute flex flex-col inset-0 bg-white bg-opacity-75 items-center justify-center text-gray-700'>
                        <FontAwesomeIcon icon={faSpinner} size='2x' className='fa-spin text-loving-600' />
                        <div className='text-xs font-semibold mt-3'>Uploading</div>
                    </div>
                )}

                <img src={fileReference.previewUrl} className='object-cover w-full h-full bg-gray-100' alt='' />

                {fileReference.uploadStatus === UploadStatus.Completed && (
                    <div className='absolute flex flex-col opacity-0 inset-0 bg-red-500 bg-opacity-50 group-hover:opacity-100 group-focus:opacity-100 items-center justify-center cursor-pointer text-white transition-opacity ease-in-out'>
                        <FontAwesomeIcon icon={faTrash} size='2x' />
                        <div className='text-xs font-semibold mt-3'>Remove</div>
                    </div>
                )}
            </li>
        </ul>
    )
}